/**
 * This source code is quoted from rc-animate.
 * homepage: https://github.com/react-component/animate
 */
import React, {Component} from 'react';
import {cssAnimation} from '../../wui-core/src';
import { AnimateChildProps } from './iAnimate';
import animUtil from './util';

const transitionMap = {
    enter: 'transitionEnter',
    appear: 'transitionAppear',
    leave: 'transitionLeave',
};

class AnimateChild extends Component<AnimateChildProps> {
    private stopper: any;
    domId: string;
    constructor(props: AnimateChildProps) {
        super(props);
        this.transition = this.transition.bind(this);
        this.stop = this.stop.bind(this);
        this.domId = `animate-child-${Math.random().toString(10).slice(2)}`
    }

    componentWillUnmount() {
        this.stop();
    }

    componentWillEnter(done: () => void) {
        if (animUtil.isEnterSupported(this.props)) {
            this.transition('enter', done);
        } else {
            done();
        }
    }

    componentWillAppear(done: () => void) {
        if (animUtil.isAppearSupported(this.props)) {
            this.transition('appear', done);
        } else {
            done();
        }
    }

    componentWillLeave(done: () => void) {
        if (animUtil.isLeaveSupported(this.props)) {
            this.transition('leave', done);
        } else {
            // always sync, do not interupt with react component life cycle
            // update hidden -> animate hidden ->
            // didUpdate -> animate leave -> unmount (if animate is none)
            done();
        }
    }

    transition(animationType: string, finishCallback: (n: any) => void) {
        const node = document.querySelector(`[data-domId="${this.domId}"]`);
        const props = this.props;
        const transitionName = props.transitionName;
        const nameIsObj = typeof transitionName === 'object';
        this.stop();
        const end = (node: any) => {
            this.stopper = null;
            finishCallback(node);
        };
        if ((cssAnimation.isCssAnimationSupported || !props.animation[animationType]) &&
			transitionName && props[transitionMap[animationType]]) {
            const name = nameIsObj ? transitionName[animationType] : `${transitionName}-${animationType}`;
            let activeName = `${name}-active`;
            if (nameIsObj && transitionName[`${animationType}Active`]) {
                activeName = transitionName[`${animationType}Active`];
            }
            this.stopper = cssAnimation(node, {
                name,
                active: activeName,
            }, end);
        } else {
            this.stopper = props.animation[animationType](node, end);
        }
    }

    stop() {
        const stopper = this.stopper;
        if (stopper) {
            this.stopper = null;
            stopper.stop();
        }
    }

    render() {
        return React.cloneElement(
            this.props.children,
            {
                'data-domId': this.domId
            },
        );
    }
}

export default AnimateChild;
